import React, { FormEvent, useEffect, useState } from 'react';
import { FormInputSearch } from '../Search/type';
import { UseFormReturn } from 'src/hooks';
import { FiSearch } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { api } from 'src/services/api';
import { Product } from 'src/model/Product';

type Search2Props = Pick<
  UseFormReturn,
  'formData' | 'formErrors' | 'onChangeFormInput'
> & {
  onSubmitSearch: (e: FormEvent) => void;
  icon: React.ReactNode;
  iconClassName?: string;
  className?: string;
  size?: 'sm' | 'md';
};

const SIZE = {
  sm: {
    form: 'p-1',
    input: 'text-sm',
    desktopIcon: 'w-5 h-5',
    mobileIcon: 'w-4 h-4',
  },
  md: {
    form: 'p-2',
    input: 'text-base',
    desktopIcon: 'w-6 h-6',
    mobileIcon: 'w-5 h-5',
  },
} as const;

export const Search2: React.FC<Search2Props> = ({
  formData,
  onChangeFormInput,
  onSubmitSearch,
  icon,
  iconClassName = '',
  className = '',
  size = 'md',
}): JSX.Element => {
  const { keyword } = useParams<{ keyword: string }>();
  const [, setProducts] = useState<Product[]>([]);
  const S = SIZE[size];

  useEffect(() => {
    const findProduct = async (): Promise<void> => {
      try {
        const response = await api.get(`/product/find/${keyword}`, {
          params: { query: keyword },
        });
        if (response.status === 200) {
          const productsList = response.data;
          const filteredProducts = productsList.filter(
            (p: { name: string }) =>
              p.name.toLowerCase() === keyword.toLowerCase()
          );
          setProducts(filteredProducts);
        }
      } catch {
        console.error('Error to fetch products');
      }
    };
    if (keyword) findProduct();
  }, [keyword]);

  return (
    <form
      onSubmit={onSubmitSearch}
      className={`flex items-center bg-white w-full gap-2 rounded-lg shadow-md ${S.form} ${className}`}
    >
      <div className="flex-grow relative">
        <input
          type="text"
          name="search"
          placeholder="Buscar no Buunpo"
          value={formData[FormInputSearch.search]}
          onChange={(e) =>
            onChangeFormInput(FormInputSearch.search)(e.target.value)
          }
          className={`w-full text-gray-600 bg-transparent border-none focus:outline-none focus:ring-0 placeholder-gray-400 ${S.input}`}
        />
      </div>

      <button
        type="submit"
        className="hidden md:flex items-center justify-center rounded-lg p-2 bg-red-500 hover:bg-red-600 transition-colors shrink-0"
      >
        {React.cloneElement(icon as React.ReactElement, {
          className: `${S.desktopIcon} text-white ${iconClassName}`,
        })}
      </button>

      <button
        type="submit"
        className="md:hidden flex items-center justify-center transition-colors shrink-0"
      >
        <FiSearch className={`${S.mobileIcon} text-red-500`} />
      </button>
    </form>
  );
};
